import { render } from "./register-card.vue?vue&type=template&id=151b7ac5"
import script from "./register-card.vue?vue&type=script&lang=js"
export * from "./register-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__